import { NotificationGroup, NotificationColor } from '@/shared/types/message';
import { NotificationItem } from './NotificationItem';
import { useMessageStyles } from '../../hooks/useMessageStyles';
import { notificationService } from '../../services/NotificationService';
import React from 'react';

interface NotificationPositionsProps {
  groups: Record<NotificationColor, NotificationGroup | null>;
}

export const NotificationPositions = React.memo(({ groups }: NotificationPositionsProps) => {
  const { getPositionClasses } = useMessageStyles();
  const config = notificationService.getConfig();

  // Filtrar grupos activos
  const activeGroups = Object.values(groups).filter(
    (group): group is NotificationGroup => group !== null,
  );

  if (activeGroups.length === 0) {
    return null;
  }

  const position = config.position;

  if (
    process.env.NODE_ENV !== 'production' &&
    ![
      'top-left',
      'top-center',
      'top-right',
      'center-left',
      'center',
      'center-right',
      'bottom-left',
      'bottom-center',
      'bottom-right',
    ].includes(position)
  ) {
    // eslint-disable-next-line no-console
    console.warn(
      `[NotificationPositions] Invalid position "${position}" from config. Using as-is.`,
    );
  }

  return (
    <div className={`${getPositionClasses(position)} ui-z-50 ui-space-y-2`}>
      {activeGroups.map((group) => {
        if (!group.notification.id) {
          if (process.env.NODE_ENV !== 'production') {
            // eslint-disable-next-line no-console
            console.warn('[NotificationPositions] Group notification without id. Skipping.');
          }
          return null;
        }
        // Key incluye count para forzar remontaje cuando llega una nueva notificación
        // Esto hace que el timer del Alert se reinicie
        return <NotificationItem key={`${group.color}-${group.count}`} group={group} />;
      })}
    </div>
  );
});

NotificationPositions.displayName = 'NotificationPositions';
